<template>
  <el-dialog
    class="auth-manage-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <div class="auth-wrap">
      <template v-for="(item, i) in typeList">
        <auth-rule
          :key="i"
          :title="item.title"
          :type="item.Type"
          :rules="voteRule"
          :result-list="getAuthItem(item.Type)"
          :role-label="roleList"
        ></auth-rule>
      </template>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleCancel">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import authRule from './authRule'
export default {
  name: 'AuthManage',
  components: {
    authRule
  },
  data() {
    return {
      title: '链权限管理',
      dialogVisible: false,
      disabled: false,
      typeList: [
        { title: '更新区块配置（BLOCK_UPDATE）', Type: 3 },
        { title: '部署合约（INIT_CONTRACT）', Type: 4 },
        { title: '升级合约（UPGRADE_UPDATE）', Type: 5 },
        { title: '冻结合约（FREEZE_CONTRACT）', Type: 6 },
        { title: '解冻合约（UNFREEZE_CONTRACT）', Type: 7 },
        { title: '废止合约（REVOKE_CONTRACT）', Type: 8 }
      ],
      voteRule: [
        { ID: 0, label: 'Majority' },
        { ID: 1, label: 'Any' },
        { ID: 2, label: 'Self' },
        { ID: 3, label: 'All' },
        { ID: 4, label: 'Forbidden' },
        { ID: 5, label: 'All' }
      ],
      orgList: [
        { label: 'Org1', value: 'Org1' },
        { label: 'Org2', value: 'Org2' }
      ],
      roleList: [
        { label: 'Admin', value: 0 },
        { label: 'Client', value: 1 }
      ],
      authList: []
    }
  },
  methods: {
    getSetting() {
      let param = {
        chainId: this.$route.query.chainId
      }
      this.$apis.chain.chainAuthManage(param).then(res => {
        if (res) {
          this.authList = res
        }
      })
    },
    handleCancel() {
      this.dialogVisible = false
    },
    handleOpen() {
      this.getSetting()
      this.dialogVisible = true
    },
    getAuthItem(type) {
      let item = this.authList.filter(ele => ele.Type === type)
      return item[0]
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('auth-manage-dialog', (), ());
.auth-manage-dialog.common-dialog {
  @include adaptation(
    (
      --auth-manage-dialog-max-height: 400px,
      --auth-manage-dialog-margin-bottom: 20px,
      --auth-manage-dialog-padding: 0 4px 0 0,
      --auth-manage-dialog-item-margin-bottom: 8px
    )
  );
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }

  .auth-wrap {
    max-height: var(--auth-manage-dialog-max-height);
    overflow-y: auto;
    margin-bottom: var(--auth-manage-dialog-margin-bottom);
    padding: var(--auth-manage-dialog-padding);

    .auth-rule:not(:last-child) {
      margin-bottom: var(--auth-manage-dialog-item-margin-bottom);
    }
  }
}
</style>
